<template>
  <div
    :class="['layer', { active: isActive }]"
    @click="setActiveLayer({ layerId: layer.id })"
    @mouseenter="showEyeIcon = true"
    @mouseleave="showEyeIcon = false"
  >
    <!-- <div class="header">
      <div class="meta flex-row-align-center">
        <icon size="20">bubble_chart</icon>
        <span>Event Totals</span>
      </div>
      <div class="controls flex-row-align-center">
        <icon size="18" @click="$emit('editLayer', layer)">edit</icon>
        <icon size="18" @click="$emit('deleteLayer', layer)">delete</icon>
      </div>
    </div>
    <div class="metric">
      <span>{{ layer.name }}</span>
      <span>{{ layer.value || "0" }}</span>
    </div>
    <div class="footer">
      <icon size="18">radio_button_unchecked</icon>
      <span>Within radius {{ layer.radius }} Kms</span>
    </div> -->

    <!-- <div class="iconContainer">
      <icon
        size="18"
        class="active"
        v-if="showEyeIcon || isActive"
        @click="setActiveLayer({ layerId: layer.id })"
        >remove_red_eye</icon
      >
      <icon size="25" v-else @click="setActiveLayer({ layerId: layer.id })"
        >bubble_chart</icon
      >
    </div> -->
    <icon size="18" class="segment-icon" @click="setActiveLayer()">{{
      isActive ? "visibility" : "visibility_off"
    }}</icon>
    <div class="layer-meta ellipsis">
      <div class="name ellipsis">
        {{ layer.name }}
      </div>
      <div class="meta ellipsis">
        <span class="ellipsis">{{
          layer.event ? layer.event.name : layer.description
        }}</span>
        <span v-if="layer.radius">{{ ` | ${layer.radius}m` }}</span>
      </div>
    </div>

    <expand />
    <div class="value">{{ formattedValue || "0" }}</div>
    <div v-if="getMode === 'EDIT'" class="controls flex-row-align-center">
      <icon size="18" @click="$emit('editLayer', layer)">edit</icon>
      <icon size="18" @click="$emit('deleteLayer', layer)">delete</icon>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { format } from "@/lib/numberFormatter";

export default {
  props: {
    isActive: Boolean,
    layer: Object,
  },
  data() {
    return {
      showEyeIcon: false,
    };
  },
  computed: {
    ...mapGetters("StaticEntity", ["isRequestInProgress", "getMode"]),
    ...mapGetters("Layers", ["getLayers"]),
    formattedValue() {
      if (!this.layer.value) return null;
      let value = parseFloat(this.layer.value);
      value = isNaN(value) ? 0 : value;
      value = format(value.toFixed(3), 2);
      return value;
    },
  },
  methods: {
    ...mapActions("Layers", ["setActiveLayer"]),
  },
};
</script>

<style lang="scss" scoped>
.layer {
  background: var(--color-secondary);
  padding: 10px 10px 10px 5px;
  border-radius: 3px;
  margin: 0px 10px 5px 10px;
  border-left: 3px solid transparent;
  display: flex;
  align-items: center;

  .segment-icon {
    padding: 10px;
    background: var(--color-secondary-light);
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0.6;
    border-radius: 5px;
    pointer-events: none;

    &:hover {
      color: var(--color-primary);
    }
  }

  &.active {
    border-left: 3px solid var(--color-primary);
    color: var(--color-primary);

    .segment-icon {
      opacity: 1;
    }
  }

  &:hover {
    cursor: pointer;
    /* background: var(--color-secondary-light); */

    .controls {
      /* opacity: 1 !important; */
      display: flex;
    }
  }

  .iconContainer {
    i {
      background-color: var(--color-secondary-light);
      border-radius: 50%;
      padding: 10px;

      &.active {
        background-color: var(--color-primary-light);
        color: var(--color-primary);
      }
    }
  }

  .layer-meta {
    margin-left: 10px;

    .name {
    }

    /* .meta-row { */
    .meta {
      display: flex;
      align-items: center;

      font-size: 0.7rem;
      opacity: 0.8;
    }
    /* } */
  }

  .value {
    font-size: 1rem;
    margin-left: 10px;
    display: flex;
    align-items: center;
  }

  .controls {
    /* opacity: 0; */
    display: none;
    margin-left: 10px;

    i {
      padding: 5px;
      margin: 0;
      border-radius: 50%;
      /* margin-left: 5px; */
      transition: 0.3s all ease-in-out;

      &:hover {
        background: var(--color-primary-light);
        color: var(--color-primary);
        cursor: pointer;
      }

      &:active {
        transform: scale(0.9);
      }

      &.active {
        background: var(--color-primary-light);
        color: var(--color-primary);
      }

      &:first-child {
        margin-left: 0;
      }
    }
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .meta {
      color: var(--color-primary);

      i {
        margin-right: 5px;
      }

      span {
        font-size: 0.8em;
      }
    }

    .controls {
      opacity: 0;

      i {
        padding: 5px;
        margin: 0;
        border-radius: 50%;
        /* margin-left: 5px; */
        transition: 0.3s all ease-in-out;

        &:hover {
          background: var(--color-primary-light);
          color: var(--color-primary);
          cursor: pointer;
        }

        &:active {
          transform: scale(0.9);
        }

        &.active {
          background: var(--color-primary-light);
          color: var(--color-primary);
        }

        &:first-child {
          margin-left: 0;
        }
      }
    }
  }

  .metric {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 5px 0;

    span {
      font-size: 1em;
    }
  }

  .footer {
    display: flex;
    align-items: center;

    i {
      margin-right: 5px;
    }

    span {
      font-size: 0.8em;
    }

    .arrow-icon {
      margin: 0 5px;
    }
  }
}
</style>
